let cached: number | null = null;

/** The screen's bottom safe area (the home indicator), in CSS px; 0 where
 *  there is none. Measured once. */
export function safeAreaBottom(): number {
  if (cached !== null) return cached;
  try {
    const probe = document.createElement('div');
    probe.style.cssText =
      'position:fixed;bottom:0;height:env(safe-area-inset-bottom, 0px);visibility:hidden;';
    document.body.appendChild(probe);
    cached = probe.getBoundingClientRect().height;
    probe.remove();
  } catch {
    cached = 0;
  }
  return cached;
}
